import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import withReactContent from "sweetalert2-react-content";
import Swal from "sweetalert2";
import { all_routes } from "../../Router/all_routes";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import Table from "../../core/pagination/datatable";
import { setToogleHeader } from "../../core/redux/action";
import { api_get, api_post } from "../../helpers/index"; // api_get and api_post for API calls

// Feather icons
import { ChevronUp, Edit, Eye, PlusCircle, RotateCcw, Trash2 } from "feather-icons-react/build/IconComponents";

const UserList = () => {
  const [dataSource, setDataSource] = useState([]);
  const [searchKeyword, setSearchKeyword] = useState("");

  const handleRetrieveList = async (keyword = "") => {
    const result = await api_get(`user/list/1?keyword=${keyword}`);

    if (result.status) {
      const totalPages = result.data.pagination.total_page;
      let allData = result.data.collection;

      for (let page = 2; page <= totalPages; page++) {
        const pageResult = await api_get(`user/list/${page}?keyword=${keyword}`);
        if (pageResult.status) {
          allData = allData.concat(pageResult.data.collection);
        }
      }

      if (allData.length > 0) {
        const dataWithKeys = allData.map((item) => ({
          ...item,
          id: item.user_name,
        }));

        setDataSource(dataWithKeys);
      }
    } else {
      setDataSource([]);
    }
  };

  useEffect(() => {
    handleRetrieveList();
  }, []);

  const handleSearch = (e) => {
    setSearchKeyword(e.target.value);
  };

  const handleSearchSubmit = (e) => {
    e.preventDefault();
    handleRetrieveList(searchKeyword);
  };

  const dispatch = useDispatch();
  const data = useSelector((state) => state.toggle_header);
  const route = all_routes;

  const columns = [
    {
      title: "Username",
      dataIndex: "user_name",
      render: (text) => <span className="prizeimgname">{text}</span>,
      sorter: (a, b) => a.user_name.localeCompare(b.user_name),
    },
    {
      title: "Name",
      dataIndex: "name",
      render: (text, record) => (
        <span className="prizeimgname">
          <Link to={`/user-details?user_name=${record.user_name}`}>{text}</Link>
        </span>
      ),
      sorter: (a, b) => a.name.localeCompare(b.name),
    },
    {
      title: "Permission",
      dataIndex: "permission",
      render: (text) => <span className="prizeimgname">{text}</span>,
      sorter: (a, b) => a.permission.localeCompare(b.permission),
    },
    {
      title: "Action",
      dataIndex: "action",
      render: (text, record) => (
        <div className="action-table-data">
          <div className="edit-delete-action">
            <div className="input-block add-lists"></div>
            <Link className="me-2 p-2" to={`/user-details?user_name=${record.user_name}`}>
              <Eye className="feather-view" />
            </Link>
            <Link className="me-2 p-2" to={`/edit-user?user_name=${record.user_name}`}>
              <Edit className="feather-edit" />
            </Link>
            <Link
              className="confirm-text p-2"
              to="#"
              onClick={() => showConfirmationAlert(record.user_name)}
            >
              <Trash2 className="feather-trash-2" />
            </Link>
          </div>
        </div>
      ),
    },
  ];

  const MySwal = withReactContent(Swal);

  const showConfirmationAlert = (user_name) => {
    MySwal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      showCancelButton: true,
      confirmButtonColor: "#00ff00",
      confirmButtonText: "Yes, delete it!",
      cancelButtonColor: "#ff0000",
      cancelButtonText: "Cancel",
    }).then(async (result) => {
      if (result.isConfirmed) {
        const deleteResult = await api_post(`user/delete/${user_name}`);
        if (deleteResult.status) {
          MySwal.fire("Deleted!", "The user has been deleted.", "success");
          handleRetrieveList(searchKeyword); // Refresh the list after deletion
        } else {
          MySwal.fire("Error!", "There was an error deleting the user.", "error");
        }
      }
    });
  };

  const renderRefreshTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Refresh
    </Tooltip>
  );

  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <h4>User List</h4>
              <h6>Manage your users</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top" onClick={() => handleRetrieveList(searchKeyword)}>
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  id="collapse-header"
                  className={data ? "active" : ""}
                  onClick={(e) => {
                    e.preventDefault();
                    dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
          </ul>
          <div className="page-btn">
            <Link to={route.addUser} className="btn btn-added">
              <PlusCircle className="me-2 iconsize" />
              Add New User
            </Link>
          </div>
        </div>
        <div className="card table-list-card">
          <div className="card-body">
            <div className="table-top">
              <div className="search-set">
                <form onSubmit={handleSearchSubmit} className="search-input">
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control form-control-sm formsearch"
                    value={searchKeyword}
                    onChange={handleSearch}
                  />
                  <button type="submit" className="btn btn-searchset">
                    <i data-feather="search" className="feather-search" />
                  </button>
                </form>
              </div>
            </div>
            <div className="table-responsive">
              <Table columns={columns} dataSource={dataSource} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserList;
